export interface CollectedVerificationIssue {
  step: string;
  severity: string;
  category: string;
  message: string;
}

export interface StreamingVerificationIssue {
  severity: string;
  category: string;
  message: string;
}

/**
 * Keep only the latest verification issues for a given step.
 * Retries can emit multiple verification results over time; phase gating should
 * reflect the final result for that step, not every transient failure.
 */
export function replaceStepVerificationIssues(params: {
  existingIssues: CollectedVerificationIssue[];
  step: string;
  latestIssues?: StreamingVerificationIssue[] | null;
}): CollectedVerificationIssue[] {
  const { existingIssues, step, latestIssues } = params;

  const retained = existingIssues.filter((issue) => issue.step !== step);
  const normalizedLatest = (latestIssues || []).map((issue) => ({
    step,
    severity: issue.severity,
    category: issue.category,
    message: issue.message,
  }));

  return [...retained, ...normalizedLatest];
}
